import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';
import { OpportunitiesForYouSuccessScreenModel } from "../../model/opportunities-for-you-success.model";
import { DataOrigin } from "../../model/DataOrigin";
import { growthOpportunitiesForYouSuccessScreenMock } from "../../../../app/shared/mocks/growth-opportunities-for-you-success-screen-mock";
import { CommunicatorNativeRemoteConfigService } from "../../../../app/shared/service/comunicator-native/communicator-native-remote-config/communicator-native-remote-cofing.service";

@Injectable({
  providedIn: "root",
})
export class OpportunitiesForYouTestAbService {

  private dataSubject: BehaviorSubject<OpportunitiesForYouSuccessScreenModel> =
    new BehaviorSubject<OpportunitiesForYouSuccessScreenModel>(null);
  private dataOrigin = DataOrigin.Mobile;

  constructor(private communicatorNative: CommunicatorNativeRemoteConfigService) {}

  /**
   * @returns Observable<OpportunitiesForYouSuccessScreenModel>
   * @description Retorna os dados do serviço
   */
  public getData(): Observable<OpportunitiesForYouSuccessScreenModel> {
    return this.dataSubject.asObservable();
  }

  /**
   * @returns void
   * @param data recebe JSON com os dados do serviço
   * @description Seta os dados do serviço
   */
  private setData(data: OpportunitiesForYouSuccessScreenModel): void {
    this.dataSubject.next(data);
  }

  /**
   * @returns void
   * @description Inicializa os dados do serviço
   */
  // comentando por conta do sonar
  // public initData(remoteKey: string): void {
  //   if (this.dataSubject.getValue() !== null) {
  //     return;
  //   } else if (this.dataOrigin == DataOrigin.Mock) {
  //       this.setData(growthOpportunitiesForYouSuccessScreenMock);      
  //     } else {  
  //       const remoteData =  this.communicatorNative.getRemoteConfigCommunicator<string>(remoteKey);
  //       remoteData
  //         .then((data) => this.setData(JSON.parse(data)))
  //         .catch((_) => this.dataSubject.next(undefined));            
  //     }
  // }
}
